import { Carousel } from 'react-responsive-carousel';
import { BASE_IMG_URL } from 'const/ConstBase';
import AppLinkButton from 'components/app/AppLinkButton';

import './AboutPage.scss';

const AboutPage = () => {
    return (
        <div className='about-page'>
            <div className='about-container'>
                <div className='about-image-wrapper'>
                    <img
                        className='about-image'
                        src={`${BASE_IMG_URL}lutador_about_main.webp`}
                        alt='about-main'
                    />
                </div>
                <p className='about-desc'>
                    Lutador Metamorfo é um jogo de luta online 3D para PC que
                    oferece uma experiência de combate casual, mas profunda,
                    onde você luta usando várias artes marciais e
                    transformações. É um jogo free-to-play (com alguns conteúdos
                    pagos), e os fãs de jogos de luta vão se divertir ainda mais
                    jogando.
                </p>

                <h1 className='about-header jogo'>Recursos do Jogo</h1>
                <div className='carousel-container'>
                    <Carousel showArrows infiniteLoop>
                        <div
                            className='slide-wrapper'
                            style={{
                                backgroundImage: `url(${BASE_IMG_URL}lutador_about_slide_one.webp)`,
                            }}
                        >
                            <div className='first-slide slide-content'>
                                <h2 className='slide-title'>
                                    Sistema de Combate Avançado:
                                </h2>
                                <p className='slide-desc'>
                                    Lutador Metamorfo apresenta um sistema que
                                    permite combates envolventes com controles
                                    simples. Os jogadores podem utilizar artes
                                    marciais famosas de todo o mundo, como
                                    Capoeira brasileira, boxe e Taekwondo,
                                    possibilitando diversos estilos de jogo
                                    pessoais.
                                </p>
                                <h2 className='slide-title'>
                                    Participação do Campeão dos Jogos Asiáticos:
                                </h2>
                                <p className='slide-desc'>
                                    Um jogador que ganhou a medalha de ouro na
                                    categoria Street Fighter nos Jogos Asiáticos
                                    de 2023 participou da fase de planejamento
                                    inicial, tornando o sistema de combate de
                                    Lutador Metamorfo mais refinado e
                                    sofisticado.
                                </p>
                            </div>
                        </div>
                        <div
                            className='slide-wrapper'
                            style={{
                                backgroundImage: `url(${BASE_IMG_URL}lutador_about_slide_two.webp)`,
                            }}
                        >
                            <div className='second-slide slide-content'>
                                <h2 className='slide-title second-slide-title'>
                                    Participação do Campeão dos Jogos Asiáticos:
                                </h2>
                                <p className='slide-desc second-slide-desc'>
                                    O exclusivo sistema de transformação em
                                    Lutador Metamorfo permite que os jogadores
                                    transformem seus personagens durante o
                                    combate usando itens específicos. As
                                    transformações podem mudar o fluxo da
                                    batalha e alterar completamente a atmosfera
                                    do jogo, proporcionando uma experiência de
                                    jogo mais diversificada.
                                </p>
                            </div>
                        </div>
                        <div
                            className='slide-wrapper'
                            style={{
                                backgroundImage: `url(${BASE_IMG_URL}lutador_about_slide_three.webp)`,
                            }}
                        >
                            <div className='third-slide slide-content'>
                                <h2 className='slide-title third-slide-title'>
                                    Modos de Combate Ricos:
                                </h2>
                                <p className='slide-desc third-slide-desc'>
                                    Uma variedade de modos de combate está
                                    disponível, desde duelos um a um até
                                    batalhas em equipe. Os jogadores também
                                    podem competir contra oponentes de IA no
                                    modo PvE ou desafiar outros no modo PvP.
                                </p>
                            </div>
                        </div>
                        <div
                            className='slide-wrapper'
                            style={{
                                backgroundImage: `url(${BASE_IMG_URL}lutador_about_slide_four.webp)`,
                            }}
                        >
                            <div className='fourth-slide slide-content'>
                                <h2 className='slide-title fourth-slide-title'>
                                    Personagens Diversos e Personalização:
                                </h2>
                                <p className='slide-desc fourth-slide-desc'>
                                    Os jogadores podem escolher entre uma
                                    variedade de personagens e personalizá-los
                                    com trajes únicos, acessórios, manuais de
                                    artes marciais e o Gem Core, que permite
                                    transformações, permitindo um estilo de
                                    combate distinto.
                                </p>
                            </div>
                        </div>
                        <div
                            className='slide-wrapper'
                            style={{
                                backgroundImage: `url(${BASE_IMG_URL}lutador_about_slide_four.webp)`,
                            }}
                        >
                            <div className='fifth-slide slide-content'>
                                <h2 className='slide-title fifth-slide-title'>
                                    Comunidade e Eventos:
                                </h2>
                                <p className='slide-desc fifth-slide-desc'>
                                    Lutador Metamorfo apoia atividades
                                    comunitárias vibrantes. Os jogadores podem
                                    participar de eventos e torneios regulares
                                    para ganhar várias recompensas e honras.
                                    Forme uma equipe com amigos para desfrutar
                                    de jogabilidade cooperativa.
                                </p>
                            </div>
                        </div>
                    </Carousel>
                </div>

                <h1 className='about-header historia'>História</h1>
                <div
                    className='historia-container'
                    style={{
                        backgroundImage: `url(${BASE_IMG_URL}lutador_historia_background.webp)`,
                    }}
                >
                    <div className='historia-mask'></div>

                    <div className='historia-content'>
                        <h3 className='historia-title'>
                            O Selamento do Rei Demônio Paimon
                        </h3>
                        <p className='historia-desc'>
                            Há muito tempo, o Rei Demônio Paimon, seduzido pelo
                            poder das trevas, tentou conquistar o mundo com a
                            ajuda de humanos corrompidos. No entanto, os humanos
                            conseguiram selar o Rei Demônio através de um ataque
                            desesperado. Os humanos corrompidos que seguiam o
                            Rei Demônio se esconderam nas sombras, aguardando
                            uma oportunidade para quebrar o selo.
                        </p>

                        <div className='image-wrapper'>
                            <img
                                src={`${BASE_IMG_URL}lutador_historia_image_one.webp`}
                                alt='historia_1'
                            />
                        </div>

                        <h3 className='historia-title'>
                            O Nascimento de Lutador Metamorfo
                        </h3>
                        <p className='historia-desc'>
                            Os heróis que selaram Paimon não eram apenas
                            habilidosos em diversas artes marciais, mas também
                            possuíam a habilidade especial de maximizar seu
                            poder através de transformações. Conhecidos como
                            Lutador Metamorfo, eles selaram seus poderes em
                            gemas e os transmitiram através das gerações,
                            continuando seus esforços para impedir a
                            ressurreição de Paimon.
                        </p>

                        <h3 className='historia-title'>
                            A Ascensão dos Guardiões das Trevas
                        </h3>
                        <p className='historia-desc'>
                            Com o passar do tempo, o Rei Demônio Paimon começou
                            a compartilhar seu poder com os humanos corrompidos
                            para preparar sua ressurreição. Esses humanos,
                            conhecidos como Guardiões das Trevas, começaram a
                            atacar Lutador Metamorfo e a buscar a destruição dos
                            selos mágicos. Esses selos consistiam em um selo
                            central e vários selos auxiliares escondidos em
                            grandes cidades ao redor do mundo.
                        </p>
                        <div className='image-wrapper'>
                            <img
                                src={`${BASE_IMG_URL}lutador_historia_image_two.webp`}
                                alt='historia_1'
                            />
                        </div>

                        <h3 className='historia-title'>
                            A Destruição dos Selos e a Crise Emergente
                        </h3>
                        <p className='historia-desc'>
                            Os Guardiões das Trevas passaram anos investigando
                            os selos auxiliares e eventualmente conseguiram
                            destruir vários deles. Embora Paimon não tenha sido
                            completamente ressuscitado, o enfraquecimento dos
                            selos permitiu que ele capacitasse os Guardiões das
                            Trevas com gemas contendo seu poder sombrio.
                            <br />
                            Os Guardiões das Trevas estão utilizando isso para
                            fortalecer seus ataques pela ressurreição do Rei
                            Demônio, e muitos dos selos auxiliares foram
                            destruídos.
                        </p>

                        <h3 className='historia-title'>
                            A Resistência de Lutador Metamorfo
                        </h3>
                        <p className='historia-desc'>
                            Com sinais de que o poder do selamento está
                            enfraquecendo, Lutador Metamorfo decidiu criar o
                            Torneio Infinito para encontrar aqueles qualificados
                            para derrotar os Guardiões das Trevas. Lutadores de
                            todas as partes do mundo, que estavam treinando em
                            isolamento, estão agora se reunindo para participar
                            do torneio.
                        </p>
                    </div>
                </div>

                <div className='about_footer'>
                    <img
                        src={`${BASE_IMG_URL}lutador_about_footer.webp`}
                        alt='historia_footer'
                    />

                    <div className='footer-buttons'>
                        <AppLinkButton
                            buttonClassName='footer-link-button'
                            buttonText='JOGUE AGORA'
                            link={''}
                            isBorderColor={false}
                        />
                        <AppLinkButton
                            buttonClassName='footer-link-button'
                            buttonText='GUIA DE JOGO'
                            link={''}
                            isBorderColor={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutPage;
